<template>
  <div class="wick-tables">
    <h4 class="table-title">
      Container Waxes
    </h4>
    <wax-usage-table :column-names="containerColumns" :wax-groups="containerWaxes" />

    <h4 class="table-title">
      Pillar Waxes
    </h4>
    <wax-usage-table :column-names="pillarColumns" :wax-groups="pillarWaxes" />
  </div>
</template>

<script>
  import { containerWaxes, pillarWaxes } from 'lib/storefront/wick-guide/data-points.js'
  import WaxUsageTable from './wax-usage-table.vue'

  const containerColumnNames = containerWaxes[0].waxes[0].sizes;
  const pillarColumnNames = pillarWaxes[0].waxes[0].sizes;

  export default {
    components: {
      WaxUsageTable
    },
    data() {
      return {
        containerColumns: containerColumnNames,
        containerWaxes,
        pillarColumns: pillarColumnNames,
        pillarWaxes
      }
    }
  };
</script>
